import { useEffect, useState } from 'react';
import { detectPreferredLanguage, splitLangFromPath, SUPPORTED_LANGUAGES } from '../context/LanguageContext';

/**
 * Inspects the current URL and — if it has no /de/ or /en/ prefix — performs a
 * hard redirect to the detected-language equivalent. Renders nothing while the
 * redirect is in flight, then renders `children` once the URL is known to be
 * language-prefixed. Must be mounted BEFORE the BrowserRouter so that
 * BrowserRouter's basename always starts with a valid language code.
 *
 * Uses `window.location.replace` (not React Router) because we need a full
 * remount so BrowserRouter can pick up its new basename.
 */
export function LanguageGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    const { lang } = splitLangFromPath(path);
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      setReady(true);
      return;
    }
    // Unprefixed URL — redirect to detected language
    const detected = detectPreferredLanguage();
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    const target = `/${detected}${path === '/' ? '' : path}${search}${hash}` || `/${detected}`;
    window.location.replace(target);
  }, []); // Runs once on mount - uses window globals and constants only

  if (!ready) return null;
  return children;
}
